import Footer from "../../components/Footer";
import VISA_1 from "../../assets/img/visa_1.png";
import VISA_2 from "../../assets/img/visa_2.png";
import PG_2 from "../../assets/img/pg_2.png";
import "../style.css";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
import { useParams } from "react-router-dom";
export default function VisaAssitance() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "Global Student Visa Service",
      desc: "Receive personalised visa guidance and support from Global StudyIn’s visa experts for a successful Global Student visa application.",
      img: VISA_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for a smooth visa application process",
      desc: "With Global StudyIn’s Premium Application Service, you’ll benefit from dedicated support every step of the way. Our experienced counsellors assist in completing your application forms, guide you in shaping a compelling personal statement, and closely monitor your submissions",
    },
    thirdSection: {
      rightSection: {
        img: VISA_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "Our Global Student Visa Service provides step-by-step assistance to simplify your student visa application process.",
      },
      leftColumnContent: [
        {
          title: "Initial consultation",
          description:
            "We conduct a free counselling session to assess your visa eligibility and requirements",
        },
        {
          title: "Document checklist",
          description:
            "We provide a list of all necessary supporting documents to compile a complete Global Student visa application",
        },
        {
          title: "Application preparation",
          description:
            "We help you accurately prepare and submit your Global Student visa application to the immigration authorities",
        },
        {
          title: "Visa appointment booking",
          description:
            "We assist you in scheduling your appointment to submit your documents at the relevant visa application center",
        },
        {
          title: "Communication with immigration authorities",
          description:
            "We communicate with the visa and immigration authorities on your behalf for a smoother visa application process",
        },
      ],
      rightColumnContent: [],
    },

    testFormatSection: {
      header: "Global Student visa types",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
      tableData: {
        rowHeader: ["Visa type", "Who can apply"],
        rowData: [
          {
            column1: "Student visa",
            column_2_header:
              "You can apply for a Global Student Visa if you are 16 years or older and meet the following requirements:",
            column2: [
              "You have received an official offer from a course provided by a licensed student sponsor.",
              "You can demonstrate that you have enough funds to cover your tuition fees and living expenses, depending on your individual situation.",
              "You have the ability to understand, speak, read, and write in English.",
            ],
          },
          {
            column1: "Student visa (family members)",
            column_2_header:
              "Your partner and children (known as ‘dependants’) may be eligible to join you in the Global or extend their stay. This is possible if you fall into any of the following categories:",
            column2: [
              "You are a full-time postgraduate student on a course at RQF level 8 or higher, with a duration of at least 9 months.",
              "You are a newly government-sponsored student enrolled in a course that lasts more than 6 months.",
              "You are studying under the Doctorate Extension Scheme.",
            ],
          },

          {
            column1: "Child student visa",
            column_2_header:
              "You can apply for a Child Student Visa if you are aged between 4 and 17 and plan to study at an independent school in the Global. To be eligible, you must meet the following conditions:",
            column2: [
              "You have received an unconditional offer to study at an independent school.",
              "You can prove that you have enough financial support to cover your course fees and living expenses while in the Global.",
              "You have permission from your parent or legal guardian to study in the Global, and this consent must be provided as part of your application.",
            ],
          },
          {
            column1: "Standard Visitor Visa",
            column_2_header: null,
            column2:
              "You can travel to the Global with a Standard Visitor Visa for purposes such as tourism, business, short-term study (up to 6 months), and other approved activities.",
          },
          {
            column1: "Short-Term Study Visa",
            column_2_header: null,
            column2:
              "You can apply for a Short-Term Study Visa if you wish to study an English language course in the Global that lasts between 6 and 11 months.",
          },
        ],
      },
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Global Student Visa Service",
      desc: "Receive personalised visa guidance and support from Global StudyIn’s visa experts for a successful Global Student visa application.",
      img: VISA_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for a smooth visa application process",
      desc: "With Global StudyIn’s Premium Application Service, you’ll benefit from dedicated support every step of the way. Our experienced counsellors assist in completing your application forms, guide you in shaping a compelling personal statement, and closely monitor your submissions",
    },
    thirdSection: {
      rightSection: {
        img: VISA_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "Our Global Student Visa Service provides step-by-step assistance to simplify your student visa application process.",
      },
      leftColumnContent: [
        {
          title: "Initial consultation",
          description:
            "We conduct a free counselling session to assess your visa eligibility and requirements",
        },
        {
          title: "Document checklist",
          description:
            "We provide a list of all necessary supporting documents to compile a complete Global Student visa application",
        },
        {
          title: "Application preparation",
          description:
            "We help you accurately prepare and submit your Global Student visa application to the immigration authorities",
        },
        {
          title: "Visa appointment booking",
          description:
            "We assist you in scheduling your appointment to submit your documents at the relevant visa application center",
        },
        {
          title: "Communication with immigration authorities",
          description:
            "We communicate with the visa and immigration authorities on your behalf for a smoother visa application process",
        },
      ],
      rightColumnContent: [],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    testFormatSection: {
      header: "Global Student visa types",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
      tableData: {
        rowHeader: ["Visa type", "Who can apply"],
        rowData: [
          {
            column1: "Student visa",
            column_2_header:
              "You can apply for a Global Student Visa if you are 16 years or older and meet the following requirements:",
            column2: [
              "You have received an official offer from a course provided by a licensed student sponsor.",
              "You can demonstrate that you have enough funds to cover your tuition fees and living expenses, depending on your individual situation.",
              "You have the ability to understand, speak, read, and write in English.",
            ],
          },
          {
            column1: "Student visa (family members)",
            column_2_header:
              "Your partner and children (known as ‘dependants’) may be eligible to join you in the Global or extend their stay. This is possible if you fall into any of the following categories:",
            column2: [
              "You are a full-time postgraduate student on a course at RQF level 8 or higher, with a duration of at least 9 months.",
              "You are a newly government-sponsored student enrolled in a course that lasts more than 6 months.",
              "You are studying under the Doctorate Extension Scheme.",
            ],
          },

          {
            column1: "Child student visa",
            column_2_header:
              "You can apply for a Child Student Visa if you are aged between 4 and 17 and plan to study at an independent school in the Global. To be eligible, you must meet the following conditions:",
            column2: [
              "You have received an unconditional offer to study at an independent school.",
              "You can prove that you have enough financial support to cover your course fees and living expenses while in the Global.",
              "You have permission from your parent or legal guardian to study in the Global, and this consent must be provided as part of your application.",
            ],
          },
          {
            column1: "Standard Visitor Visa",
            column_2_header: null,
            column2:
              "You can travel to the Global with a Standard Visitor Visa for purposes such as tourism, business, short-term study (up to 6 months), and other approved activities.",
          },
          {
            column1: "Short-Term Study Visa",
            column_2_header: null,
            column2:
              "You can apply for a Short-Term Study Visa if you wish to study an English language course in the Global that lasts between 6 and 11 months.",
          },
        ],
      },
    },
    enablePaymentRedirection: true
  };
  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;

  return (
    <div className="personalised-guidance visa-assitance">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />
      <section className="table-section bg-white  py-20 test-format-section mt-8">
        <div className="test-format-div mx-auto text-center">
          {/* Title */}
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#051D62]">
            {data.testFormatSection.header}
          </h2>

          {/* Subtitle */}
          <p className="text-gray-600 max-w-3xl mx-auto text-[#4A5565]">
            {data.testFormatSection.desc}
          </p>

          {/* Table */}
          <div className="hidden md:block overflow-x-auto mt-12">
            <table className="w-full border border-gray-300 rounded-xl overflow-hidden text-left text-sm">
              {/* Table Header */}
              <thead className="bg-[#2F5ED9] text-white text-sm">
                <tr>
                  {data.testFormatSection.tableData.rowHeader.map(
                    (element, iny) => (
                      <th
                        key={iny}
                        className="p-4 font-semibold text-[#fff] table-row-container"
                      >
                        {element}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              {/* Body */}
              <tbody className="text-gray-700">
                {/* Row  */}
                {data.testFormatSection.tableData.rowData.map((row, ind) => (
                  <tr key={ind} className="border-b">
                    <td className="p-4 font-medium text-[#4A5565]">
                      {row.column1}
                    </td>
                    <td className="p-4 text-[#4A5565]">
                      {row.column_2_header != null ? (
                        <span>
                          {row.column_2_header} <br />
                        </span>
                      ) : null}
                      {Array.isArray(row.column2) ? (
                        <ul className="list-disc space-y-1">
                          {row.column2.map((item, idx) => (
                            <li key={idx}>{item}</li>
                          ))}
                        </ul>
                      ) : (
                        row.column2
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* ---------------- MOBILE VIEW ---------------- */}
          <div className="md:hidden mt-8 space-y-6 border border-gray-200 rounded-xl">
            {data.testFormatSection.tableData.rowData.map((row, ind) => (
              <div
                key={ind}
                className="bg-white border-bottom border-gray-200 p-6 shadow-sm text-left"
              >
                <p className="font-[20px] font-semibold text[#4A5565] tracking-wide">
                  Visa type
                </p>

                <p className="font-[18px] mt-1 text-[#051D62]">{row.column1}</p>
                <p className="font-[20px] font-semibold text[#4A5565] tracking-wide">
                  Who can apply
                </p>
                <p className="font-[18px] mt-1 text-[#051D62]">
                  {row.column_2_header}
                </p>
                <div className="mt-4 p-5 space-y-3">
                  {Array.isArray(row.column2) ? (
                    <ul className="list-disc space-y-1">
                      {row.column2.map((item, idx) => (
                        <li
                          key={idx}
                          className="font-[18px] mt-1 text-[#051D62]"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="font-[18px] mt-1 text-[#051D62]">
                      {row.column2}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );

}